export default class Entrega {
	constructor(
		data=''
	){
		this.data = data;
	}
}
